var map = {
	"./countries": 25384,
	"./countries-ru": 29184,
	"./countries-ru.json": 29184,
	"./countries.json": 25384,
	"./en": 59748,
	"./en.json": 59748,
	"./ru": 86958,
	"./ru.json": 86958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92947;